<template>
  <div>
    <el-popover placement="bottom" width="230" trigger="click">
      <div style="text-align: left;">
          <el-button class="button_maxsus" type="text" @click="toggleState('inverted')"><img src="../../public/img/icons/maxsus/contrast_circle_symbol.svg" class="maxsus_img"/>Qorong`ulashgan ko`rish</el-button>
          <el-button class="button_maxsus" type="text" @click="toggleState('highlighted')"><img src="../../public/img/icons/maxsus/flashlight.svg" class="maxsus_img"/>Link manzillar</el-button>
          <el-button class="button_maxsus" type="text" @click="toggleState('greyscaled')"><img src="../../public/img/icons/maxsus/blind.svg" class="maxsus_img"/>Oq-qora ko`rish</el-button>
          <el-button class="button_maxsus" type="text" @click="toggleState('accessibileFontSize')"><img src="../../public/img/icons/maxsus/font.svg" class="maxsus_img"/>Shrift o`lchami</el-button>
      </div>
      <el-button slot="reference" type="text" class="time_spec_new" size="medium" style="padding: 0px 20px; margin-right: 10px; line-height: 1.5;">
          <img src="../../public/img/icons/eye.svg" style="height: 16px; margin-right: 6px;"/>
        <span>{{ $t("app.bosh_spes") }}</span></el-button>
    </el-popover>
    <div v-show="false">
      <accessibility-toolbar ref="accessibilityToolbar" />
    </div>
  </div>
</template>

<script>
import AccessibilityToolbar from "vue-accessibility-toolbar";

export default {
  components: { AccessibilityToolbar },
  data() {
    return {
    };
  },
  methods: {
    toggleState(value) {
      let { accessibilityToolbar } = this.$refs;
      if (!accessibilityToolbar) return;
      accessibilityToolbar.toggleState(value);
    }
  }
};
</script>
<style scoped>
.button_maxsus {
    margin-left: 0px !important;
    padding: 5px 10px;
}
.button_maxsus:hover {
    margin-left: 0px !important;
    background: #ededed;
    width: -webkit-fill-available;
    padding: 5px 10px;
    text-align: left;
}
.button_maxsus:active {
    color: #fff;
    text-decoration: none;
    background-color: #96b4d3;
    width: -webkit-fill-available;
    padding: 5px 10px;
    text-align: left;
}
.maxsus_img {
    height: 16px; margin-right: 6px;
}
</style>